<template>
  <div v-if="propObj" class="wrap-school-of-creativity-detail">
    <b-row align-h="between" class="title">
      <b-col
        cols="12"
        md="6"
        class="text"
      >
        <h2>{{ propObj.title }}</h2>
      </b-col>
      <b-col
        v-if="propObj.isActiveSymposium && watchPastBtn && watchPastBtn.isDisplay"
        cols="12"
        md="3"
        class="btn"
      >
        <button
          @click="clickToVideoDetail(propObj.detailId)"
          :style="{
            backgroundColor: '#EE0300',
            color: '#ffffff',
          }"
        >
          ชมย้อนหลัง
        </button>
      </b-col>
      <b-col
        cols="12"
        md="3"
        class="btn"
      >
        <button @click="goBack">Back</button>
      </b-col>
    </b-row>

    <div class="time">
      <h3>{{ propObj.time }}</h3>
    </div>

    <b-row class="images">
      <b-col
        v-for="(speaker, i) in propObj.speakers"
        :key="i"
        cols="12"
        md="3"
        class="col"
      >
        <img :src="speaker.image">
        <p class="speaker-text">{{speaker.name}}</p>
        <p class="speaker-text" v-if="speaker.position != '' ">{{speaker.position}}</p>
        <p class="speaker-text">{{speaker.company}}</p>
      </b-col>
    </b-row>

    <div  v-if="propObj.content"
        class="synopsis">
      <h4>Synopsis:</h4>
      <span v-html="propObj.content"></span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { constantsComputed } from '@/store/helpers'

export default {
  data () {
    return {
      propObj: null
    }
  },

  computed: {
    ...constantsComputed,
    ...mapState({
      schoolCreativesRaw: state => state.creativity.schoolCreatives
    }),
    watchPastBtn () {
      return this.configMap.get('watchPastBtn')
    }
  },

  methods: {
    clickToVideoDetail (videoId) {
      sessionStorage.setItem('symposium_redirect_video_detail_id', videoId)
      window.open(`/symposium/video/${videoId}`, '_blank')
    },

    starter () {
      sessionStorage.removeItem('symposium_redirect_video_detail_id')

      const id = {
        main: parseInt(this.$route.params.mainId),
        detail: parseInt(this.$route.params.detailId)
      }

      this.mapDetail(this.schoolCreativesRaw, id)
    },

    mapDetail (data, id) {
      if (data && data.length > 0) {
        data.forEach(schoolCreative => {
          if (schoolCreative.id === id.main) {
            schoolCreative.detail.forEach(detail => {
              if (detail.id === id.detail) {
                this.propObj = {
                  detailId: detail.id,
                  isActiveSymposium: detail.is_active_symposium,
                  title: `${schoolCreative.name} ${schoolCreative.room}`,
                  time: `${detail.time_start} - ${detail.time_end}: ${detail.name}`,
                  content: detail.content,
                  speakers: []
                }

                detail.photo.forEach(photo => {
                  if (photo.image) {
                    const imgUrl = `${this.baseURL}/storage/app/img/talkdetailphoto/${photo.image}`
                    this.propObj.speakers.push({
                      image: imgUrl,
                      name: photo.name,
                      company: photo.company,
                      position: photo.position
                    })
                  }
                })
              }
            })
          }
        })
      } else {
        this.$store.dispatch('creativity/getSchoolCreativity')
      }
    },

    goBack () {
      this.$router.go(-1)
    }
  },

  watch: {
    schoolCreativesRaw () {
      this.starter()
    }
  },

  created () {
    this.starter()
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.wrap-school-of-creativity-detail {
  .title {
    padding-top: 22px;
    padding-bottom: 22px;
    align-items: center;

    .text {
      h2 {
        font-size: 1.5rem;
      }
    }

    .btn {
      button {
        width: 100%;
        height: 52px;
        background-color: $light;
        font-size: 1.5rem;
      }
    }
  }

  .time {
    padding: 15px 8px;
    background-color: $light;

    h3 {
      font-size: 1.25rem;
      color: black;
    }
  }

  .images {
    padding: 22px 0;

    .col {
      img {
        width: 100%;
        margin-bottom: 10px;
      }
    }
  }

  .synopsis {
    padding-bottom: 22px;

    h4 {
      margin: 12px 0 0 0;
      font-size: 1.75rem;
    }

    span {
      line-height: 1.2;
      font-size: 1.5rem;
    }
  }
}
.speaker-text{
  font-size: 20px;
  color: #7e8c8d;
}
</style>
